// echartsOptions详情  固定参数
import dayjs from 'dayjs';

export const echartsOptions = {
  title: {
    text: 'CPU利用率(%)',
    left: '1%',
    top: 6,
    textStyle: {
      fontWeight: '600',
      fontSize: '12',
    },
  },
  tooltip: {
    trigger: 'axis',
  },
  label: {
    formatter: (value) => dayjs(Number(value.value)).format('YYYY-MM-DD HH:mm:ss'),
    align: 'right',
  },
  grid: {
    top: '14%',
    left: '7%',
    right: '9%',
    bottom: '8%',
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    axisLabel: {
      show: true,
    },
  },
  yAxis: {
    type: 'value',
  },
  toolbox: {
    right: 10,
    feature: {
      saveAsImage: {},
    },
  },
  series: {
    name: 'CPU利用率(%)',
    type: 'line',
    stack: 'Total',
    showSymbol: false,
    data: [],
    lineStyle: {
      color: '#409eff',
      width: 0.6,
    },
  },
};

// 时间快捷选项
export const dateShortcuts = [
  {
    text: '5分钟',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 300 * 1000);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '30分钟',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 1800 * 1000);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '1小时',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '12小时',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 12);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '24小时',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '7天',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    },
  },
  {
    text: '30天',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    },
  },
];

// 火山云 监控图表列表
export const myLineChartListVolcengine = [
  // cpu 监控
  [
    {
      loading: false,
      name: 'CPU使用率(%)',
      dom: null,
      key: 'CpuTotal',
      leftDistance: '102',
      value: '实例CPU总使用率',
      conversion: 1,
    },
  ],
  // 内存 监控
  [
    {
      loading: false,
      name: '内存使用率(%)',
      dom: null,
      key: 'MemoryUsedUtilization',
      leftDistance: '102',
      value: '实例已用内存量占总内存量的比例',
      conversion: 1,
    },
  ],
  // 磁盘监控
  [
    {
      loading: false,
      name: '磁盘使用率(%)',
      dom: null,
      key: 'DiskUsageUtilization',
      leftDistance: '112',
      value: '实例磁盘已用容量占总容量比例',
      conversion: 1,
    },
    {
      loading: false,
      name: '磁盘剩余空间(GiB)',
      dom: null,
      key: 'DiskUsageAvail',
      leftDistance: '122',
      value: '实例磁盘可用容量',
      conversion: 1024 * 1024 * 1024,
    },
  ],
  // 网络监控
  [
    {
      loading: false,
      name: '网络流入速率(Kibit/s)',
      dom: null,
      key: 'NetworkInRate',
      leftDistance: '144',
      value: '实例网络每秒流入比特数',
      conversion: 1024,
    },
    {
      loading: false,
      name: '网络流出速率(Kibit/s)',
      dom: null,
      key: 'NetworkOutRate',
      leftDistance: '144',
      value: '实例网络每秒流出比特数',
      conversion: 1024,
    },
  ],
];

// 华为云 监控图表列表
export const myLineChartListHuaweicloud = [
  // cpu 监控
  [
    {
      loading: false,
      name: 'CPU使用率(%)',
      dom: null,
      key: 'cpu_usage',
      leftDistance: '102',
      value: '该指标用于统计测量对象当前CPU使用率',
      conversion: 1,
    },
    {
      loading: false,
      name: 'CPU一分钟平均负载',
      dom: null,
      key: 'load_average1',
      leftDistance: '130',
      value: '该指标用于统计测量对象过去1分钟的CPU平均负载',
      conversion: 1,
    },
    {
      loading: false,
      name: 'CPU五分钟平均负载',
      dom: null,
      key: 'load_average5',
      leftDistance: '130',
      value: '该指标用于统计测量对象过去5分钟的CPU平均负载',
      conversion: 1,
    },
    {
      loading: false,
      name: 'CPU十五分钟平均负载',
      dom: null,
      key: 'load_average15',
      leftDistance: '130',
      value: '该指标用于统计测量对象过去15分钟的CPU平均负载',
      conversion: 1,
    },
  ],
  // 内存 监控
  [
    {
      loading: false,
      name: '内存使用率(%)',
      dom: null,
      key: 'mem_usedPercent',
      leftDistance: '102',
      value: '该指标用于统计测量对象的内存使用率。',
      conversion: 1,
    },
  ],
  // 磁盘监控
  [
    {
      loading: false,
      name: '磁盘使用率(%)',
      dom: null,
      key: 'disk_usedPercent',
      leftDistance: '102',
      value: '该指标用于统计测量对象磁盘使用率',
      conversion: 1,
    },
  ],
  // 网络监控
  [
    {
      loading: false,
      name: '出网带宽(Kibit/s)',
      dom: null,
      key: 'net_bitRecv',
      leftDistance: '118',
      value: '该指标用于统计测量对象网卡每秒发送的流量 。',
      conversion: 1024,
    },
    {
      loading: false,
      name: '入网带宽(Kibit/s)',
      dom: null,
      key: 'net_bitSent',
      leftDistance: '118',
      value: '该指标用于统计测量对象网卡每秒接收的流量。',
      conversion: 1024,
    },
    {
      loading: false,
      name: '网卡包接收速率(Counts/s)',
      dom: null,
      key: 'net_packetRecv',
      leftDistance: '168',
      value: '该指标用于统计测量对象网卡每秒接收的数据包数。',
      conversion: 1,
    },
    {
      loading: false,
      name: '网卡包发送速率(Counts/s)',
      dom: null,
      key: 'net_packetSent',
      leftDistance: '168',
      value: '该指标用于统计测量对象网卡每秒发送的数据包数。',
      conversion: 1,
    },
  ],
];

// 阿里云 监控图表列表
export const myLineChartListalicloud = [
  // cpu 监控
  [
    {
      loading: false,
      name: 'CPU使用率(%)',
      dom: null,
      key: 'CPUUtilization',
      leftDistance: '102',
      value: 'CPU使用率',
      conversion: 1,
    },
  ],
  // 内存 监控
  [
    {
      loading: false,
      name: '内存使用率(%)',
      dom: null,
      key: 'memory_usedutilization',
      leftDistance: '102',
      value: '内存使用率。',
      conversion: 1,
    },
  ],
  // 磁盘监控
  [
    {
      loading: false,
      name: '磁盘使用率(%)',
      dom: null,
      key: 'diskusage_utilization',
      leftDistance: '102',
      value: '磁盘使用率',
      conversion: 1,
    },
    {
      loading: false,
      name: '磁盘读取BPS (bytes/s)',
      dom: null,
      key: 'DiskReadBPS',
      leftDistance: '150',
      value: '磁盘读取BPS,',
      conversion: 1024,
    },
    {
      loading: false,
      name: '磁盘写入BPS (bytes/s)',
      dom: null,
      key: 'DiskWriteBPS',
      leftDistance: '150',
      value: '磁盘写入BPS',
      conversion: 1024,
    },
  ],
  // 网络监控
  [
    {
      loading: false,
      name: '公网流入带宽(bits/s)',
      dom: null,
      key: 'VPC_PublicIP_InternetInRate',
      leftDistance: '136',
      value: '公网流入带宽。',
      conversion: 1024,
    },
    {
      loading: false,
      name: '公网流出带宽(bits/s)',
      dom: null,
      key: 'VPC_PublicIP_InternetOutRate',
      leftDistance: '136',
      value: '公网流出带宽。',
      conversion: 1024,
    },
    {
      loading: false,
      name: '内网流入带宽(bits/s)',
      dom: null,
      key: 'IntranetInRate',
      leftDistance: '136',
      value: '内网流入带宽。',
      conversion: 1024,
    },
    {
      loading: false,
      name: '内网流出带宽(bits/s)',
      dom: null,
      key: 'IntranetOutRate',
      leftDistance: '136',
      value: '内网流出带宽。',
      conversion: 1024,
    },
  ],
];
